module.exports = __webpack_public_path__ + "img/m3.69e8dc86.svg";